import { Button, Input, Textarea } from "@chakra-ui/react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { selectSelectedCell, updateCell } from "../../store/slices/node.slice";

const NucleusControlPanel: React.FC = () => {
    const selectedCell = useSelector(selectSelectedCell);
    const dispatch = useDispatch();

    const [isGoalsFormVisible, setIsGoalsFormVisible] = useState(false);
    const [isDescriptionFormVisible, setIsDescriptionFormVisible] = useState(false);

    const [formGoal, setFormGoal] = useState(selectedCell?.goal || "");
    const [formAnalysis, setFormAnalysis] = useState(selectedCell?.analysis || "");

    if (!selectedCell) {
        return <></>;
    }

    return (
        <div id="nucleus-control-panel" className="nucleus-control panel-contents">
            <div className="control-panel-header">
                <h1 className="title">Nucleus</h1>
                <h2 className="subtitle">Manage the nucleus of your cell</h2>
            </div>

            {!isGoalsFormVisible && (
                <div className="goals-container">
                    <button onClick={() => setIsGoalsFormVisible(true)} className="edit-btn">
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 24 24"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"></path>
                        </svg>
                    </button>
                    <h2 className="description-title">What is the goal of this cell</h2>
                    <div id="nucleus_goals_content" className="goals-list">
                        {selectedCell.goal}
                    </div>
                </div>
            )}

            {isGoalsFormVisible && (
                <div className="goals-form nucleus-form">
                    <Textarea
                        id="goals-input"
                        placeholder="Enter goals"
                        rows={5}
                        value={formGoal}
                        onChange={(e) => setFormGoal(e.target.value)}
                    />
                    <div className="flex gap-2 justify-end mt-4">
                        <Button
                            id="save-nucleus-goal-btn"
                            size="sm"
                            colorScheme="blue"
                            onClick={() => {
                                setIsGoalsFormVisible(false);
                                dispatch(
                                    updateCell({
                                        unique_identifier: selectedCell.unique_identifier,
                                        goal: formGoal
                                    })
                                );
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            onClick={() => {
                                setIsGoalsFormVisible(false);
                                setFormGoal(selectedCell.goal);
                            }}
                            size="sm"
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            )}

            {!isDescriptionFormVisible && (
                <div className="description-container">
                    <button onClick={() => setIsDescriptionFormVisible(true)} className="edit-btn">
                        <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 24 24"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"></path>
                        </svg>
                    </button>
                    <h2 className="description-title">Analysis</h2>
                    <p id="nucleus-description-text" className="description-text">
                        {selectedCell.analysis}
                    </p>
                </div>
            )}

            {isDescriptionFormVisible && (
                <div className="description-form nucleus-form">
                    <h2 className="description-title">Analysis</h2>
                    <Textarea
                        id="nucleus-description-input"
                        placeholder="Enter description"
                        rows={5}
                        value={formAnalysis}
                        onChange={(e) => setFormAnalysis(e.target.value)}
                    ></Textarea>
                    <div className="flex gap-2 justify-end mt-4">
                        <Button
                            id="save-nucleus-description-btn"
                            size="sm"
                            colorScheme="blue"
                            onClick={() => {
                                setIsDescriptionFormVisible(false);
                                dispatch(
                                    updateCell({
                                        unique_identifier: selectedCell.unique_identifier,
                                        analysis: formAnalysis
                                    })
                                );
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            size="sm"
                            colorScheme="gray"
                            onClick={() => {
                                setIsDescriptionFormVisible(false);
                                setFormAnalysis(selectedCell.analysis);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            )}

            <h2 className="panel-title">Nucleus Input</h2>

            <ReactSelect
                className="react-select-container"
                classNamePrefix="react-select"
                options={[
                    { value: "open_ia", label: "Open AI GPT 3.5" },
                    { value: "open_4", label: "Open AI GPT 4" }
                ]}
                styles={{
                    option: (provided) => ({
                        ...provided,
                        color: "black"
                    }),
                    singleValue: (provided) => ({
                        ...provided,
                        color: "black"
                    })
                }}
            />

            <div className="reasoning-container">
                <p className="label mb-3 text-[14px] font-medium">Number of Iterations</p>
                <Input placeholder="Number of iterations" />
                {/* <div className="input-control">
                    <label className="label" style={{ color: 'white' }} htmlFor="number_of_iterations">
                        Number of Iterations
                    </label>
                    <input id="number_of_iterations" style={{ color: 'black' }} type="text" className="input"
                        placeholder="Number of iterations" />
                </div> */}
            </div>
        </div>
    );
};

export default NucleusControlPanel;
